import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import {
  ORIGIN_LOCATION_TYPE,
  DESTINATION_LOCATION_TYPE,
  CURRENT_LOCATION_TYPE,
} from '#/shared/constants';
import * as Styled from './styled';

function LocationTypeIcon({ locationType }) {
  if (locationType === CURRENT_LOCATION_TYPE) {
    return <Styled.CurrentLocationBadge />;
  }

  return <Styled.EndpointIcon $locationType={locationType} />;
}

LocationTypeIcon.propTypes = {
  locationType: PropTypes.oneOf([
    DESTINATION_LOCATION_TYPE,
    ORIGIN_LOCATION_TYPE,
    CURRENT_LOCATION_TYPE,
  ]).isRequired,
};

/**
 * The `@opentripplanner/endpoints-overlay` component converts the supplied
 * marker to static markup so it will work with leaflet, but this breaks things
 * for styled-component's theme provider (see the `useComponentAsLeafletIcon`
 * hook in this project for details).  This higher-order component passes the
 * theme directly and massages the prop names so MapEndpointIcon will be fully
 * functional within otp-ui
 */
function IconWithOtpUiCompatibility() {
  const theme = useContext(ThemeContext);

  function LocationTypeIconWrapper({ type, location }) {
    const geocodedLocation = location?.name;

    return (
      <Styled.MapEndpointIcon
        theme={theme}
        $locationType={type}
        title={geocodedLocation}
      />
    );
  }

  LocationTypeIconWrapper.propTypes = {
    type: PropTypes.oneOf([DESTINATION_LOCATION_TYPE, ORIGIN_LOCATION_TYPE])
      .isRequired,
    location: PropTypes.shape({
      name: PropTypes.string,
    }),
  };

  LocationTypeIconWrapper.defaultProps = {
    location: null,
  };

  return LocationTypeIconWrapper;
}

export default LocationTypeIcon;
export { IconWithOtpUiCompatibility };
